<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="3"
      y="0"
      width="18"
      height="24"
    >
      <path
        d="M13.667 5.269c.592 0 1.073-.483 1.073-1.08V2.711c0-.598-.482-1.08-1.073-1.08h-3.334c-.592 0-1.074.482-1.074 1.08v1.476c0 .598.482 1.08 1.074 1.08h3.334Zm0 1.63h-3.334A2.712 2.712 0 0 1 7.62 4.19V2.711A2.712 2.712 0 0 1 10.333 0h3.334a2.712 2.712 0 0 1 2.712 2.712v1.476A2.711 2.711 0 0 1 13.667 6.9Zm3.4 3.028h1.64v9.113h-1.64V9.927ZM6.934 19.04H5.294V5.78A3.146 3.146 0 0 1 8.44 2.635v1.632c-.831 0-1.507.677-1.507 1.515v13.26Zm-2.294.815v1.084c0 .791.638 1.43 1.422 1.43h11.878c.784 0 1.422-.639 1.422-1.43v-1.084H4.64ZM17.939 24H6.06A3.06 3.06 0 0 1 3 20.94v-2.716h18v2.715A3.06 3.06 0 0 1 17.939 24Zm.136-20.872 1.506.643c-2.822 6.55-8.673 11.522-15.542 13.42L3.6 15.619c6.398-1.767 11.851-6.402 14.475-12.49Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        d="M13.667 5.269c.592 0 1.073-.483 1.073-1.08V2.711c0-.598-.482-1.08-1.073-1.08h-3.334c-.592 0-1.074.482-1.074 1.08v1.476c0 .598.482 1.08 1.074 1.08h3.334Zm0 1.63h-3.334A2.712 2.712 0 0 1 7.62 4.19V2.711A2.712 2.712 0 0 1 10.333 0h3.334a2.712 2.712 0 0 1 2.712 2.712v1.476A2.711 2.711 0 0 1 13.667 6.9Zm3.4 3.028h1.64v9.113h-1.64V9.927ZM6.934 19.04H5.294V5.78A3.146 3.146 0 0 1 8.44 2.635v1.632c-.831 0-1.507.677-1.507 1.515v13.26Zm-2.294.815v1.084c0 .791.638 1.43 1.422 1.43h11.878c.784 0 1.422-.639 1.422-1.43v-1.084H4.64ZM17.939 24H6.06A3.06 3.06 0 0 1 3 20.94v-2.716h18v2.715A3.06 3.06 0 0 1 17.939 24Zm.136-20.872 1.506.643c-2.822 6.55-8.673 11.522-15.542 13.42L3.6 15.619c6.398-1.767 11.851-6.402 14.475-12.49Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
